var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FormToggleSwitch",class:{active: _vm.value},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"ball",class:{active: _vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }